import React from 'react';
import classNames from 'classnames';
import styles from './index.module.scss';
import LargeModal, {LargeModalProps} from '../LargeModal';

interface StackModalProps extends LargeModalProps {}

const StackModal: React.FC<StackModalProps> = ({className, ...extraProps}) => {
    return (
        <LargeModal
            className={classNames(styles.root, className)}
            {...extraProps}
        />
    );
};

StackModal.defaultProps = {
    mask: false,
    maskClosable: false,
};

export default StackModal;
